import { useState } from "react";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import FormInputField from "@/components/lib/from-input-field";
import { useEffect } from "react";

function VatSelector({ form, name = "vat", label = "VAT / Tax" }) {
  const vat = form.watch(name);
  useEffect(() => {
    if (vat === 0) {
      form.setValue(name, "0")
    }
  }, [])
  
  
  const [showVAT, setShowVAT] = useState(false); // ✅ starts closed
                                                   
  return (
    <div>
      <div className="flex gap-2 items-center">
        <Switch
          checked={showVAT || vat || vat === Number(0)}
          onCheckedChange={(val) => {
            setShowVAT(val);

            if (!val) {
              // when turned OFF, clear VAT value
              form.setValue(name, "");
            } else {
              // when turned ON, optionally set default
              if (!vat) form.setValue(name, "0");
            }
          }}
        />
        <Label>{label}</Label>
      </div>

      {(vat || showVAT || vat === 0) && (
        <div className="flex gap-5 justify-between items-end">
          <div className="w-full mt-4">
            <FormInputField
              name={name}
              style="w-full bg-cblack7"
              form={form}
              placeholder="Select VAT"
              type="select"
              selectOption={[
                { label: "0%", value: "0" },
                { label: "20%", value: "20" }
              ]}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default VatSelector;
